export const useLoadingStore = defineStore('loading', {
  state: () => ({
    isLoading: false
  }),
  actions: {
    setLoading(value: boolean) {
      this.isLoading = value
    }
  }
}) 